import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface TenantBrandSettings {
  id: number;
  slug: string;
  name: string;
  company_name: string;
  timezone: string;
  brand_name: string;
  legal_entity: string;
  business_address: string;
  gm_name: string;
  gm_email: string;
  gm_phone: string;
  callback_phone: string;
  owner_name: string;
  owner_email: string;
  dashboard_base_url: string;
  feedback_base_url: string;
  booking_link: string;
  public_marketing_base_url: string;
  public_reviews_url: string;
  unsubscribe_email: string;
  cockpit_base_url: string;
  smtp_from_name: string;
  smtp_from_email: string;
  allowed_origins: string[];
  vonigo_franchise_id: number;
}

async function fetchJson<T>(path: string, init: RequestInit): Promise<T> {
  const res = await fetch(path, init);
  if (!res.ok) throw new Error(`Failed to fetch ${path}: ${res.status}`);
  return res.json() as Promise<T>;
}

export function useTenantBrandSettings() {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["settings", "brand"],
    queryFn: () => fetchJson<TenantBrandSettings>("/api/cockpit/settings/brand", { headers }),
  });
}

export function useSaveTenantBrandSettings() {
  const headers = useAuthHeaders(true);
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: Partial<TenantBrandSettings>) => fetchJson<TenantBrandSettings>("/api/cockpit/settings/brand", {
      method: "PATCH",
      headers,
      body: JSON.stringify(payload),
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settings", "brand"] }),
  });
}
